// extracted by mini-css-extract-plugin
export default {"title":"LodgingDetails_title__-loRp","segment":"LodgingDetails_segment__wDDiO","edit":"LodgingDetails_edit__wrykj"};